module.exports = __webpack_public_path__ + "static/media/uploadFile.e05ac385.png";